import React, { useContext, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./DeleteCliente.css";
import { Button, Input } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import question_icon from "../../../../assets/images/question.png";
import axios from "axios";

const DeleteCliente = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  const [isLoading, setIsLoading] = useState(false);
  const [senhaAdministrador, setSenhaAdministrador] = useState("");

  const token = authInfo?.dataUser?.token;
  const { id } = useParams();

  const deleteHandler = async () => {
    if (!senhaAdministrador.trim()) {
      setNotiMessage({
        type: "warning",
        message: "Digite a senha do administrador geral para confirmar a exclusão.",
      });
      return;
    }

    setIsLoading(true);

    const config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_SERVIDOR}/cliente/${id}`,
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: {
        senhaAdministrador,
      },
    };

    try {
      await axios.request(config);
      setSenhaAdministrador("");
      setNotiMessage({
        type: "success",
        message: "Cliente excluído definitivamente com sucesso.",
      });
      navigate(links.DASHBOARD_CLIENTES);
    } catch (err) {
      const status = err?.response?.status;
      const mensagem =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Não foi possível excluir o cliente.";

      setNotiMessage({
        type: "error",
        message: mensagem,
      });

      if (status === 401) {
        setNotiMessage({
          type: "error",
          message: "Sua sessão expirou. Entre novamente.",
        });
        if (dataUser?.key === "ADMIN") {
          navigate(links.ADMIN_SIGNIN);
        } else {
          navigate(links.SIGNIN);
        }
        setDataUser(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="Delete_Cliente_Content">
        <img
          className="Delete_Cliente_Icon"
          src={question_icon}
          alt="question icon"
        />
        <p className="Delete_Cliente_Text">Deseja excluir este cliente?</p>
        <p className="Delete_Cliente_Confirmacao_Text">
          Para excluir definitivamente, digite a senha do administrador geral.
        </p>
        <Input.Password
          className="Delete_Cliente_Senha"
          value={senhaAdministrador}
          onChange={(e) => setSenhaAdministrador(e.target.value)}
          onPressEnter={deleteHandler}
          placeholder="Senha do administrador geral"
          autoComplete="current-password"
          disabled={isLoading}
        />
        <div className="Delete_Cliente_Btns">
          <Button
            className="Delete_Cliente_Cancel_Btn"
            disabled={isLoading}
            onClick={() => {
              navigate(`${links.EDITAR_CLIENTES}/${id}`, {
                state: location.state,
              });
            }}
          >
            <span>NÃO</span>
          </Button>{" "}
          <Button
            className="Delete_Cliente_Delete_Btn"
            danger
            disabled={isLoading || !senhaAdministrador.trim()}
            onClick={deleteHandler}
          >
            <span>CONFIRMAR EXCLUSÃO</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCliente;
